import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '../utils/request'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    component: () => import('../layout/MainLayout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { title: '概览' },
      },
      {
        path: 'loans',
        name: 'Loans',
        component: () => import('../views/loan/List.vue'),
        meta: { title: '贷款订单' },
      },
      {
        path: 'members',
        name: 'Members',
        component: () => import('../views/member/List.vue'),
        meta: { title: '会员用户' },
      },
      {
        path: 'pull-token-logs',
        name: 'PullTokenLogs',
        component: () => import('../views/pullToken/LogList.vue'),
        meta: { title: 'USDT 转出记录' },
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.public) {
    if (to.name === 'Login' && getToken()) {
      next({ name: 'Dashboard' })
      return
    }
    next()
    return
  }
  if (!getToken()) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
